// admin/src/pages/ScimIntegrations/scimStatusStyle.js

/**
 * Returns universal status styling for SCIM chips so text color is green for active
 * and standard universal colors for other statuses (never pure white text).
 *
 * @param {string} status - status string ('active', 'suspended', 'inactive', 'disabled', etc.)
 * @param {string|object} modeOrTheme - 'light' | 'dark' | theme object
 * @returns {object} sx style object for MUI Chip
 */
export function getStatusChipSx(status, modeOrTheme = 'light') {
  const s = String(status || '').toLowerCase().trim();
  const isDark =
    typeof modeOrTheme === 'string'
      ? modeOrTheme === 'dark'
      : modeOrTheme?.palette?.mode === 'dark';

  let color = isDark ? '#4caf50' : '#2e7d32'; // Universal green
  let bg = isDark ? 'rgba(76, 175, 80, 0.16)' : 'rgba(46, 125, 50, 0.12)';
  let border = isDark ? 'rgba(76, 175, 80, 0.4)' : 'rgba(46, 125, 50, 0.35)';

  if (s === 'active' || s === 'synced' || s === 'resolved' || s === 'success') {
    // Universal Green
    color = isDark ? '#4caf50' : '#2e7d32';
    bg = isDark ? 'rgba(76, 175, 80, 0.16)' : 'rgba(46, 125, 50, 0.12)';
    border = isDark ? 'rgba(76, 175, 80, 0.4)' : 'rgba(46, 125, 50, 0.35)';
  } else if (
    s === 'suspended' ||
    s === 'pending' ||
    s === 'paused' ||
    s === 'warning' ||
    s === 'circuit_open'
  ) {
    // Universal Amber / Orange
    color = isDark ? '#ff9800' : '#ed6c02';
    bg = isDark ? 'rgba(255, 152, 0, 0.16)' : 'rgba(237, 108, 2, 0.12)';
    border = isDark ? 'rgba(255, 152, 0, 0.4)' : 'rgba(237, 108, 2, 0.35)';
  } else if (
    s === 'inactive' ||
    s === 'disabled' ||
    s === 'failed' ||
    s === 'error' ||
    s === 'conflict' ||
    s === 'revoked' ||
    s === 'failure'
  ) {
    // Universal Red
    color = isDark ? '#f44336' : '#d32f2f';
    bg = isDark ? 'rgba(244, 67, 54, 0.16)' : 'rgba(211, 47, 47, 0.12)';
    border = isDark ? 'rgba(244, 67, 54, 0.4)' : 'rgba(211, 47, 47, 0.35)';
  } else {
    // Universal Neutral / Gray
    color = isDark ? '#9ca3af' : '#5f6368';
    bg = isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.06)';
    border = isDark ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.15)';
  }

  return {
    color,
    backgroundColor: bg,
    border: `1px solid ${border}`,
    fontWeight: 600,
    textTransform: 'capitalize',
  };
}
